__turbopack_context__.v({
  "root": "LoyaltySection-module-scss-module__s36w6a__root",
  "slide": "LoyaltySection-module-scss-module__s36w6a__slide",
  "swiper": "LoyaltySection-module-scss-module__s36w6a__swiper",
});
